const initialState = {
  camera: false,
  frontCamera: true,
};

function cameraReducer(state = initialState, action = '') {
  switch (action.type) {
    case 'camera/start':
      return {
        ...state,
        camera: true,
      };
    case 'camera/stop':
      return {
        ...state,
        camera: false,
      };
    case 'camera/switchCamera':
      return {
        ...state,
        frontCamera: !state.frontCamera,
      };
    default:
      return state;
  }
}

export default cameraReducer;
